import { render, staticRenderFns } from "./BlockWarning.vue?vue&type=template&id=37056be4&scoped=true&"
import script from "./BlockWarning.vue?vue&type=script&lang=ts&"
export * from "./BlockWarning.vue?vue&type=script&lang=ts&"
import style0 from "./BlockWarning.vue?vue&type=style&index=0&id=37056be4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37056be4",
  null
  
)

export default component.exports